import React from 'react';
import { Countdown } from '../Countdown';
import { PriceCard } from '../PriceCard';
import { Reveal } from '../Reveal';
export function CierreFinal() {
  return <section aria-labelledby="cierre-titulo" className="w-full bg-bordo-dark px-4 py-16 sm:px-6 sm:py-20" data-id="element-90" data-mp="3kpgnh4pgg7dp">
      <div className="mx-auto max-w-4xl" data-id="element-91" data-mp="3tobq66taizc9">
        <Reveal data-id="element-92" data-mp="3tn8yvxs22uvt">
          <Countdown className="ring-dorado/30" data-id="element-93" data-mp="3tnsakwr44n1e" />
        </Reveal>

        <Reveal delay={0.05} data-id="element-94" data-mp="2wyue9a3psh24">
          <div className="mt-12 text-center" data-id="element-95" data-mp="2wzmb0o91sktz">
            <h2 id="cierre-titulo" className="font-display text-3xl font-bold text-white sm:text-5xl" data-id="element-96" data-mp="30zd6v6dflr5d">
              Llevate tu Profes de Telas <span className="text-verde" data-id="element-97" data-mp="35xofxevwjxmj">Resuelto</span>™
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base text-white/75 sm:text-lg" data-id="element-98" data-mp="3apzhsna7dthq">
              Los 7 tomos, los 5 bonos y los 12 meses de planificación en una sola oferta.
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.07} data-id="element-99" data-mp="2i83o06hrtq14">
          <div className="mt-10" data-id="element-100" data-mp="2i7291qxmwje4">
            <PriceCard theme="dark" ctaLabel="💥 SÍ, QUIERO TODO EL SISTEMA" data-id="element-101" data-mp="1ijw5k082t535" />
          </div>
        </Reveal>
      </div>
    </section>;
}